<template>
  <div class="page-add">
    <div class="add-title">专题详情</div>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="130px"
    >
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" APP是否展示：" required>
            <el-radio-group disabled v-model="subjectForm.isApp">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" WEB是否展示：" required>
            <el-radio-group disabled v-model="subjectForm.isWeb">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" 小程序是否展示：" required>
            <el-radio-group disabled v-model="subjectForm.isApplet">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" PC端是否展示：" required>
            <el-radio-group disabled v-model="subjectForm.isPc">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="专题名称：">
            <el-input readonly v-model="subjectForm.subjectName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="专题标签：">
            <el-input
              maxlength="4"
              v-model="subjectForm.subjectTag"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="专题简介：">
            <el-input
              v-model="subjectForm.subjectDesc"
              type="textarea"
              :rows="3"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col>
          <el-form-item class="scale" label="专题排序：" required>
            <el-input v-model="subjectForm.order" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <div>
          <el-col :span="8" v-if="subjectForm.isWeb == '1'">
            <el-form-item class="scale" label="配图：">
              <div
                v-if="subjectForm.webCover"
                id="video-output"
                @mouseenter="showCover1 = true"
                @mouseleave="showCover1 = false"
              >
                <img :src="subjectForm.webCover" class="avatar" />
                <div v-show="showCover1" class="cover-bg">
                  <i
                    class="el-icon-zoom-in delete"
                    @click.stop="showViewer1 = true"
                  ></i>
                </div>
              </div>
              <div class="upload_tip">
                <p>WEB封面</p>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="subjectForm.isApp == '1'">
            <el-form-item class="scale" :label="subjectForm.isWeb == '0' ? '配图：':''">
              <div
                v-if="subjectForm.appCover"
                id="video-output"
                @mouseenter="showCover2 = true"
                @mouseleave="showCover2 = false"
              >
                <img :src="subjectForm.appCover" class="avatar" />
                <div v-show="showCover2" class="cover-bg">
                  <i
                    class="el-icon-zoom-in delete"
                    @click.stop="showViewer2 = true"
                  ></i>
                </div>
              </div>
              <div class="upload_tip">
                <p>APP封面</p>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="subjectForm.isApplet == '1'">
            <el-form-item class="scale" :label="(subjectForm.isWeb == '0' && subjectForm.isApp == '0') ? '配图：':''">
              <div
                v-if="subjectForm.dingCover"
                id="video-output"
                @mouseenter="showMiniCover = true"
                @mouseleave="showMiniCover = false"
              >
                <img :src="subjectForm.dingCover" class="avatar" />
                <div v-show="showMiniCover" class="cover-bg">
                  <i
                    class="el-icon-zoom-in delete"
                    @click.stop="showMiniViewer = true"
                  ></i>
                </div>
              </div>
              <div class="upload_tip">
                <p>小程序封面</p>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="subjectForm.isPc == '1'">
            <el-form-item class="scale" :label="(subjectForm.isWeb == '0' && subjectForm.isApp == '0' && subjectForm.isApplet == '0') ? '配图：':''">
              <div
                v-if="subjectForm.pcCover"
                id="video-output"
                @mouseenter="showPcCover = true"
                @mouseleave="showPcCover = false"
              >
                <img :src="subjectForm.pcCover" class="avatar" />
                <div v-show="showPcCover" class="cover-bg">
                  <i
                    class="el-icon-zoom-in delete"
                    @click.stop="showPcViewer = true"
                  ></i>
                </div>
              </div>
              <div class="upload_tip">
                <p>PC端封面</p>
              </div>
            </el-form-item>
          </el-col>
        </div>
      </el-row>
      <el-row>
        <el-form-item class="scale" label="专题背景：" prop="bgCover">
          <el-col :span="8">
            <el-form-item class="scale">
              <div
                v-if="subjectForm.bgCover"
                id="video-output"
                @mouseenter="showCover3 = true"
                @mouseleave="showCover3 = false"
              >
                <img :src="subjectForm.bgCover" class="avatar" />
                <div v-show="showCover3" class="cover-bg">
                  <i
                    class="el-icon-zoom-in delete"
                    @click.stop="showViewer3 = true"
                  ></i>
                </div>
              </div>
              <div class="upload_tip">
                <p>专题背景</p>
              </div>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-row>
      <el-form-item label="专题版块：">
        <el-row>
          <el-col
            :span="colNum"
            v-for="(item, index) in subjectForm.subjectBlockList"
            :key="index"
          >
            <div class="subjectBlock">
              <div class="subjectBlock-top">
                <div class="blockName">
                  <img
                    v-if="item.blockType == 0"
                    src="../../../assets/image/video_block_icon.png"
                  />
                  <img
                    v-else-if="item.blockType == 1"
                    src="../../../assets/image/news_block_icon.png"
                  />
                  <img
                    v-else-if="item.blockType == 2"
                    src="../../../assets/image/book_block_icon.png"
                  />
                  <img
                    v-else
                    src="../../../assets/image/magazine_block_icon.png"
                  />
                  <span :title="item.blockName">{{ item.blockName }}</span>
                </div>
                <p>版块类型：{{ item.blockTypeName }}</p>
                <p>版块状态：{{ item.onlineStatusName }}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-row>
        <el-col>
          <el-form-item class="form-handle" label-width="0">
            <el-button @click="goBack">返回</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-image-viewer
      v-if="showViewer1"
      :on-close="
        () => {
          showViewer1 = false;
        }
      "
      :url-list="[subjectForm.webCover]"
    />
    <el-image-viewer
      v-if="showViewer2"
      :on-close="
        () => {
          showViewer2 = false;
        }
      "
      :url-list="[subjectForm.appCover]"
    />
    <el-image-viewer
      v-if="showMiniViewer"
      :on-close="
        () => {
          showMiniViewer = false;
        }
      "
      :url-list="[subjectForm.dingCover]"
    />
    <el-image-viewer
      v-if="showViewer3"
      :on-close="
        () => {
          showViewer3 = false;
        }
      "
      :url-list="[subjectForm.bgCover]"
    />
    <el-image-viewer
      v-if="showPcViewer"
      :on-close="
        () => {
          showPcViewer = false;
        }
      "
      :url-list="[subjectForm.pcCover]"
    />
  </div>
</template>

<script>
import { getSubjectInfo } from "@/api/subjectInfo";
import { getSysParamByTypes } from "@/api/sysParam";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  components: { ElImageViewer },
  data() {
    return {
      subjectForm: {
        subjectName: "",
        subjectDesc: "",
        order: 0,
        webCover: "",
        appCover: "",
        isApplet: "",
        isApp: "",
        isWeb: "",
        isPc: "",
        bgCover: "",
        pcCover: "",
        subjectBlockList: [],
      },
      publicData: [],
      showCover1: false,
      showCover2: false,
      showMiniCover: false,
      showCover3: false,
      showPcCover: false,
      showViewer1: false,
      showViewer2: false,
      showMiniViewer: false,
      showViewer3: false,
      showPcViewer: false,
      colNum: 8,
    };
  },
  created() {
    this.getSysParamByTypes([
      "RECOMMEND_TAG",
      "VIDEO_SOURCE",
      "VIDEO_TYPE",
      "IS_VALID",
    ]);
    if (this.$route.query.id) {
      getSubjectInfo({ uuid: this.$route.query.id }).then((res) => {
        if (!res || res.code != 0) return;
        this.subjectForm = res.data;
        this.subjectForm.isApplet = String(this.subjectForm.isApplet);
        this.subjectForm.isApp = String(this.subjectForm.isApp);
        this.subjectForm.isWeb = String(this.subjectForm.isWeb);
        this.subjectForm.isPc = this.subjectForm.isPc == 1 ? "1" : "0";
        // this.subjectForm.isApplet = JSON.stringify(this.subjectForm.isApplet);
        // this.subjectForm.isApp = JSON.stringify(this.subjectForm.isApp);
        // this.subjectForm.isWeb = JSON.stringify(this.subjectForm.isWeb);
        // this.subjectForm.isPc = JSON.stringify(this.subjectForm.isPc);
      });
    }
  },
  mounted() {
    const _this = this;
    window.onresize = () => {
      return (() => {
        _this.listenScreenWidth();
      })();
    };
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.publicData = res.data["IS_VALID"] || [];
        // this.subjectForm.isApp = this.publicData[1].paramKey;
        // this.subjectForm.isWeb = this.publicData[1].paramKey;
        // this.subjectForm.isApplet = this.publicData[1].paramKey;
        // this.subjectForm.isPc = this.publicData[1].paramKey;
      });
    },
    goBack() {
      this.$router.push("/subjectInfo");
    },
    // 监听屏幕宽度，设置排版
    listenScreenWidth() {
      this.colNum = 8;
      window.screenWidth = document.body.clientWidth;
      let screenWidth = window.screenWidth;
      if (screenWidth > 1680) {
        this.colNum = 6;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 12px;
@mixin text {
  color: $textColor;
  font-size: $textSize;
}
/deep/ .scale .el-input {
  @include text;
}
.subjectBlock {
  height: 146px;
  width: 290px;
  border-radius: 6px;
  border: 1px solid rgba(237, 241, 248, 1);
  margin-bottom: 32px;
  margin-left: 40px;
  .subjectBlock-top {
    padding: 21px 32px 12px 32px;
    p {
      line-height: 17px;
      color: #51627d;
      margin-top: 20px;
    }
    .blockName {
      color: #343c4a;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      img {
        width: 20px;
        height: auto;
        margin-right: 8px;
      }
    }
  }
  .subjectBlock-footer {
    height: 40px;
    width: 250px;
    position: relative;
    left: 0;
    bottom: 0;
    display: flex;
    background-color: #edf1f8;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    .footer-item {
      height: 100%;
      display: flex;
      align-items: center;
    }
    img {
      width: 21px;
      height: auto;
      cursor: pointer;
    }
  }
}
.subjectBlock:nth-child(3n + 1) {
  margin-left: 0px;
}
#video-output {
  width: 280px;
  height: 160px;
  position: relative;
  .avatar {
    width: 280px;
    height: 160px;
    display: block;
    object-fit: cover;
  }
  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;
    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}
.upload_tip {
  width: 280px;
  text-align: center;
  margin-top: 10px;
}
.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 30px;
  color: #51627d;
}
.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}
</style>
